/**
 * Counterpart site URL for the header language switcher.
 * - localhost / 127.0.0.1 → fixed dev ports (JP 3000, EN 3001), same path + query + hash
 * - *.vercel.app → algomori-jp / algomori-en production URLs, same path + query + hash
 * - otherwise → primary production domains, same path + query + hash
 *
 * Optional env overrides (highest priority): VITE_JP_SITE_URL, VITE_EN_SITE_URL
 *
 * @param {'jp' | 'en'} target
 * @returns {string}
 */
function pathQueryHash() {
  if (typeof window === 'undefined' || !window.location) return '/'
  const { pathname, search, hash } = window.location
  return `${pathname}${search}${hash}` || '/'
}

export function getCrossSiteUrl(target) {
  const envJp =
    typeof import.meta.env.VITE_JP_SITE_URL === 'string' ? import.meta.env.VITE_JP_SITE_URL.trim() : ''
  const envEn =
    typeof import.meta.env.VITE_EN_SITE_URL === 'string' ? import.meta.env.VITE_EN_SITE_URL.trim() : ''
  if (target === 'jp' && envJp) return envJp
  if (target === 'en' && envEn) return envEn

  if (typeof window === 'undefined' || !window.location) {
    return target === 'jp' ? 'https://www.algomori.co.jp/' : 'https://www.algomori.com/'
  }

  const { hostname, protocol } = window.location
  const pq = pathQueryHash()
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1'

  if (isLocal) {
    return target === 'jp' ? `${protocol}//${hostname}:3000${pq}` : `${protocol}//${hostname}:3001${pq}`
  }

  if (hostname.includes('vercel.app')) {
    return target === 'jp'
      ? `https://algomori-jp.vercel.app${pq}`
      : `https://algomori-en.vercel.app${pq}`
  }

  return target === 'jp' ? `https://www.algomori.co.jp${pq}` : `https://www.algomori.com${pq}`
}
